<template>
  <div class="events">
    <v-toolbar flat class="d-flex flex-no-wrap align-center justify-end">
      <v-btn @click="removeGameDrawer" class="mr-md-5">
        {{ $t("Remove Game") }}
        <!-- <v-icon>mdi-plus</v-icon> -->
      </v-btn>
      <router-link :to="`/games/add/`">
        <v-btn> {{ $t("Add Game") }} </v-btn>
      </router-link>
    </v-toolbar>
    <v-container class="v-step-0">
      <v-container class="pa-6 pt-10" fluid>
        <v-container fluid>
          <v-row dense>
            <v-col
              v-for="event in events"
              :key="event.name"
              class="col-12 col-lg-3"
            >
              <v-card class="game-card">
                <v-img
                  :src="event.header"
                  class="white--text align-end"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  height="200px"
                >
                </v-img>
                <v-card-text>
                  <v-card-title v-text="event.name"></v-card-title>
                  <v-card-subtitle v-text="event.dates"></v-card-subtitle>
                </v-card-text>
                <v-card-actions class="v-step-2">
                  <v-spacer></v-spacer>
                  <router-link :to="`/games/${event.id}`">
                    <v-btn icon>
                      <v-icon>mdi-arrow-right</v-icon>
                    </v-btn>
                  </router-link>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-container>
    </v-container>

    <v-navigation-drawer floating right absolute temporary v-model="drawer">
      <template v-slot:prepend>
        <v-container fluid class="py-10">
          <v-row>
            <v-col cols="6" class="align-center v-step-1">
              <h1>{{ $t("Add Game") }}</h1>
            </v-col>
          </v-row>
        </v-container>
      </template>
      <v-divider></v-divider>

      <v-container fluid class="py-10">
        <v-row>
          <v-col cols="12" class="align-center">
            <v-card elevation="0" class="px-5">
              <v-row>
                <v-col cols="6" class="align-center">
                  <v-text-field label="Name" v-model="game.name"></v-text-field>
                </v-col>
                <v-col cols="6" class="align-center">
                  <v-text-field
                    label="Dates"
                    v-model="game.dates"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="align-center">
                  <h3 class="pt-5 ma-0 grey--text text--lightend-5">
                    {{ $t("Banner") }}
                  </h3>
                  <MediaPopUp />
                  <v-img :src="game.header" height="25vh" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="d-flex justify-end">
                  <v-col class="text-right">
                    <v-btn color="green lighten-2" text @click="saveGame">
                      {{ $t("Ok") }}
                    </v-btn>
                    <v-btn color="red lighten-2" text @click="reset">
                      {{ $t("Cancel") }}
                    </v-btn>
                  </v-col>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-navigation-drawer>
    <v-navigation-drawer
      floating
      right
      absolute
      temporary
      v-model="drawerDelete"
    >
      <template v-slot:prepend>
        <v-container fluid class="py-10">
          <v-row>
            <v-col cols="6" class="align-center">
              <h1>{{ $t("Remove Game") }}</h1>
            </v-col>
          </v-row>
        </v-container>
      </template>
      <v-divider></v-divider>

      <v-container fluid class="py-10">
        <v-row>
          <v-col cols="12" class="align-center">
            <v-card flat>
              <v-row no-gutters class="d-flex align-center border-bottom pb-5">
                <v-col class="d-flex align-center">
                  <p class="pl-4 ma-0">{{ $t("Name") }}</p>
                </v-col>
                <v-col class="d-flex align-center">
                  <p class="pl-4 ma-0">{{ $t("Dates") }}</p>
                </v-col>
                <v-col class="d-flex align-center"> </v-col>
              </v-row>

              <v-hover v-for="event in events" :key="event.name">
                <v-row
                  no-gutters
                  class="d-flex align-center border-bottom pb-5"
                >
                  <v-col class="d-flex align-center">
                    <p class="pl-4 ma-0">{{ event.name }}</p>
                  </v-col>
                  <v-col class="d-flex align-center">
                    <p class="pl-4 ma-0">{{ event.dates }}</p>
                  </v-col>
                  <v-col class="d-flex align-center">
                    <v-btn @click="removeGame(event)" plain class="red--text">
                      {{ $t("Delete") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-hover>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-navigation-drawer>
    <tours :steps="steps" />
  </div>
</template>

<script>
/* eslint-disable */
import { firebaseApp } from "@/config/firebase";
import firebase from "firebase/app";
const db = firebase.firestore(firebaseApp);
import EventBus from "../../config/eventBus";

import gameProvider from "@/modules/Games/data/games";

export default {
  name: "Games",
  route: {
    path: "/games/",
    name: "Games",
  },
  data() {
    return {
      events: [],
      drawer: false,
      drawerDelete: false,
      game: {
        name: "",
        dates: "",
        header: "",
        about: "",
      },
      steps: new Array(
        {
          target: ".v-step-0",
          header: {
            title: "Welcome!",
          },
          content: `This is the game pages!  Here you can access all the different games that are currently available.`,
        },
        {
          target: ".v-step-1",
          content: `Click this button to add a new game!`,
        },
        {
          target: ".v-step-2",
          content: `Click the arrow to the right to see the game you just added!`,
        }
      ),
    };
  },
  components: {
    MediaPopUp: () =>
      import("../../components/MediaUploader/MediaSelector.vue"),
  },
  beforeMount() {
    this.getEvents();
  },
  mounted() {
    let self = this;
    EventBus.$on("IMAGE_PICKED", function (payLoad) {
      self.game.header = payLoad.url;
    });
  },
  unmounted() {
    EventBus.$off("IMAGE_PICKED");
  },
  methods: {
    removeGameDrawer() {
      this.drawerDelete = !this.drawerDelete;
    },
    async removeGame(game) {
      let self = this;
      gameProvider.deleteSingleGame(game.id).then(function (events) {
        self.events = events;
        self.drawerDelete = false;
      });
    },
    async saveGame() {
      let self = this;
      gameProvider.addSingleGame(this.game).then(function (events) {
        self.events = events;
        this.game = {
          name: "",
          event: "",
          header: "",
          about: "",
        };
        self.drawer = false;
      });
    },
    reset() {
      this.game = {
        name: "",
        event: "",
        header: "",
        about: "",
      };
      this.drawer = false;
    },
    async getEvents() {
      let self = this;
      gameProvider.getEvents().then(function (events) {
        self.events = events;
      });
    },
  },
  computed: {},
};
</script>

<style lang="scss">
.events {
  .v-navigation-drawer {
    position: fixed;
    width: 70% !important;
  }
  .v-overlay--active {
    position: fixed;
  }
  .drawer-card {
    height: 100%;
    padding: 10%;
  }
}
.game-card {
  min-height: 370px;
}
</style>
